module.exports = __webpack_public_path__ + "static/img/A61802_1.e6f4a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61802_1.png
// module id = MnVG
// module chunks = 1